/**
 * Entry
 */
import Project from './project'

new Project()
